module.exports = __webpack_public_path__ + "static/media/4.669189c2.jpg";